// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"wba-z","sponsoredTooltipWrapper":"xba-z","sponsoredTooltip":"yba-z","newCard":"zba-z"};